import './related-posts.component.scss'

import { breakpoints } from '../../application/utils/breakpoints'
import { Swiper, Pagination } from 'swiper'
Swiper.use(Pagination)

if(!document.getElementById('shopify-section-product-template')){
  document.querySelectorAll('.related-posts__slider').forEach((root) => {
    const swiperElement = root.querySelector('.swiper-container')
    new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 16,
      allowTouchMove: true,
      pagination: {
        el: root.querySelector('.swiper-pagination'),
        clickable: true
      },
      breakpoints: {
        [breakpoints.medium]: {
          slidesPerView: 3,
          allowTouchMove: false
        },
        [breakpoints.tablet]: {
          slidesPerView: 2,
          allowTouchMove: true
        }
      }
    })
  })
}